/*
 * Authors: mariushirjanu
 * Created: 28/11/2023
 */
import { Injectable } from '@angular/core';

export const STORAGE_LOGIN:string = 'ga2.login';
export const STORAGE_PROFILE_ID:string = 'ga2.bpprofiles.profileId';
export const STORAGE_TOKEN:string = 'ga2.token';
export const STORAGE_ALTERNATE_USER:string = 'ga2.alternate';
export const STORAGE_REMEMBER:string = 'ga2.remember';
export const STORAGE_REPORT_LAYOUT_SETTINGS:string = 'ga2.report.layoutSettings';
export const STORAGE_REPORT_LS_START_TIME:string = 'ga2.report.lsStartTime';
export const STORAGE_REPORT_LS_END_TIME:string = 'ga2.report.lsEndTime';

@Injectable()
export class GaWebStorageService {
  public local:StorageLocation;
  public session:StorageLocation;

  constructor() {
    this.local = new StorageLocation('localStorage');
    this.session = new StorageLocation('sessionStorage');
  }
}

class StorageLocation {
  private storage:Storage;

  constructor(storageName:string) {
    this.storage = window[storageName];
  }

  public set(key:string, item:any):void {
    this.storage.setItem(key, JSON.stringify(item));
  }

  public get(key:string):any {
    const value:string = this.storage.getItem(key);
    return value && JSON.parse(value);
  }

  public remove(key:string):void {
    this.storage.removeItem(key);
  }

  public clear():void {
    this.storage.clear();
  }
}